import { getIrrigationStatusColors } from 'App/Map/_utils/getIrrigationStatusColors'
import { translate } from 'i18n/i18n'
import { colors } from 'settings/colors'

export const IrrigationChartLegend = ({
  showPressure = false,
  showScheduled = false,
}: {
  showPressure?: boolean
  showScheduled?: boolean
}) => {
  const colorStyles = {
    margin: '0px 4px 0px 10px',
    height: 15,
    width: 15,
    display: 'inline-block',
  }

  const onColor = getIrrigationStatusColors('on').backgroundColor
  const offColor = getIrrigationStatusColors('off').backgroundColor
  const unknownColor = getIrrigationStatusColors('unknown').backgroundColor

  return (
    <div css={{ display: 'flex', padding: '5px 10px 0', fontSize: 14, fontWeight: 'bold' }}>
      {showPressure && (
        <div css={{ display: 'flex', alignItems: 'center', paddingRight: '10px' }}>
          <span
            css={{
              ...colorStyles,
              background: colors.midnight,
              height: '2px',
              width: '17px',
            }}
          />
          <span>{translate.phrases.banyanApp('Pressure')}</span>
        </div>
      )}
      {showScheduled && (
        <div css={{ display: 'flex', alignItems: 'center', paddingRight: '10px' }}>
          <span
            css={{
              ...colorStyles,
              background: colors.lightGreen,
              border: colors.lightGreen,
            }}
          />
          <span css={{ fontSize: 14 }}>{translate.phrases.banyanApp('Scheduled')}</span>
        </div>
      )}
      <div css={{ display: 'flex', alignItems: 'center', paddingRight: '10px' }}>
        <span css={{ ...colorStyles, background: onColor }} />
        <span>{translate.phrases.banyanApp('On')}</span>
      </div>
      <div css={{ display: 'flex', alignItems: 'center', paddingRight: '10px' }}>
        <span css={{ ...colorStyles, background: offColor }} />
        <span>{translate.phrases.banyanApp('Off')}</span>
      </div>
      <div css={{ display: 'flex', alignItems: 'center' }}>
        <span css={{ ...colorStyles, background: unknownColor }} />
        <span>{translate.phrases.banyanApp('No Data')}</span>
      </div>
    </div>
  )
}
